export default __webpack_public_path__ + "static/media/5i.3a0fda1f.png";